import axios from '../localAxios';
import { transferOwnershipUrl } from './urls';

interface TransferOwnershipParams {
  teamId: string;
  newOwnerPublicId: string;
}

export async function transferOwnership({
  teamId,
  newOwnerPublicId,
}: TransferOwnershipParams) {
  const url = transferOwnershipUrl({ teamId, newOwnerPublicId });
  const result = await axios.post<{ data: string }>(url.href);
  return result.data;
}
